var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { heicTo, isHeic } from 'heic-to';
import { optimizeImage } from './optimize-image';
export const mergeFilesIntoPdf = (name, files) => __awaiter(void 0, void 0, void 0, function* () {
    const { PDFDocument } = yield import('pdf-lib');
    const doc = yield PDFDocument.create();
    for (const file of files) {
        const type = file.type;
        const fileBytes = yield file.arrayBuffer();
        if (yield isHeic(file)) {
            const jpeg = yield heicTo({
                blob: file,
                type: 'image/jpeg',
                quality: 0.5,
            });
            yield addImageToPDF(doc, jpeg);
            continue;
        }
        if (type.includes('image')) {
            yield addImageToPDF(doc, file);
            continue;
        }
        if (type === 'application/pdf') {
            const existingPdf = yield PDFDocument.load(fileBytes);
            const copiedPages = yield doc.copyPages(existingPdf, existingPdf.getPageIndices());
            copiedPages.forEach((page) => doc.addPage(page));
            continue;
        }
        throw new Error(`Unsupported format: ${type}`);
    }
    const mergedPdfBytes = yield doc.save();
    const mergedPdfBlob = new Blob([mergedPdfBytes], { type: 'application/pdf' });
    const pdfUrl = URL.createObjectURL(mergedPdfBlob);
    return {
        url: pdfUrl,
        name: `${name}.pdf`,
        file: new File([mergedPdfBlob], `${name}.pdf`, { type: 'application/pdf' }),
    };
});
const addImageToPDF = (pdfDoc, file) => __awaiter(void 0, void 0, void 0, function* () {
    const optimizedFile = yield optimizeImage(file, 0.5);
    const fileBytes = yield optimizedFile.arrayBuffer();
    const image = file.type.includes('png') ? yield pdfDoc.embedPng(fileBytes) : yield pdfDoc.embedJpg(fileBytes);
    const page = pdfDoc.addPage([image.width, image.height]);
    page.drawImage(image, {
        x: 0,
        y: 0,
        width: image.width,
        height: image.height,
    });
});
